import GenericError from '../GenericError'
import { StationAdapter } from '../Adapters/StationAdapter';
import { DatabaseInfo } from './../Database/DatabaseInterface';

class WebSQL extends StationAdapter {

	createTable(db, table, columns) {
		db.transaction(function (transaction) {
			transaction.executeSql("CREATE TABLE IF NOT EXISTS " + table + " (" + columns + ")", [], (transaction, result) => {
			}, (transaction, error) => console.log("Create table Error " + error.message));
		});
	};

	insert(table, values, columns) {
		return new Promise((resolve, reject) => {
			var db = openDatabase(DatabaseInfo.dbName, DatabaseInfo.version, DatabaseInfo.name, DatabaseInfo.size);

			if (!db) {
				this.error("Database hasn't been opened!");
			} else {
				this.createTable(db, table, columns);

				var valuesCount = "";

				for (let i = 1; i <= values[0].length; i++) {
					if (i === values[0].length) {
						valuesCount += "?";
					} else {
						valuesCount += "?,";
					}
				}

				db.transaction((transaction) => {
					for (var i = 0; i < values.length; i++) {
						transaction.executeSql('INSERT INTO ' + table + ' (' + columns + ')  VALUES (' + valuesCount + ')', values[i], (transaction, result) => {
							resolve(result);
						}, (transaction, error) => {
							var e = new GenericError();
							e.setAndLogMessage("Insertion Error: " + error.message);
							reject(e);
						});
					}
				}, (transaction, error) => {
					var e = new GenericError();
					e.setAndLogMessage("Error: " + error.message);
					reject(e);
				});
			}
		})
	}

	fetchSpecificData = (table, column, values) => {
		return new Promise((resolve, reject) => {
			var db = openDatabase(DatabaseInfo.dbName, DatabaseInfo.version, DatabaseInfo.name, DatabaseInfo.size);
			var list = [];

			if (!db) {
				console.log("Database hasn't been created!");
			} else {
				var columnStatement = "";
				for (let i = 0; i < column.length; i++) {
					if (i === column.length - 1) {
						columnStatement += column[i] + "=? "
					} else {
						columnStatement += column[i] + "=? AND ";
					}

				}

				db.transaction((transaction) => {
					transaction.executeSql('SELECT * FROM ' + table + ' WHERE ' + columnStatement, values, (transaction, result) => {
						if (result != null && result.rows != null) {
							for (var i = 0; i < result.rows.length; i++) {
								var row = result.rows.item(i);
								list.push(this.fromApi(row));
							}

							resolve(list);
						}
					}, (transaction, error) => {
						var e = new GenericError();
						e.setAndLogMessage("Error: " + error.message);
						reject(e);
					});
				}, (transaction, error) => {
					var e = new GenericError();
					e.setAndLogMessage("Error: " + transaction.message);
					reject(e);
				});
			}
		})
	}

	fetch(table, columns, values, operators) {
		return new Promise((resolve, reject) => {
			var db = openDatabase(DatabaseInfo.dbName, DatabaseInfo.version, DatabaseInfo.name, DatabaseInfo.size);
			var list = [];

			if (!db) {
				console.log("Database hasn't been created!");
			} else {
				let conditionStatement = "";

				if (columns != null && columns.length > 0) {
					conditionStatement += " WHERE ";
					conditionStatement += this._createConditionStatement(columns, operators);
				} else {
					conditionStatement += ";";
				}

				if (values == null) {
					values = [];
				}

				let sqlStatement = 'SELECT * FROM ' + table + conditionStatement;
				db.transaction((transaction) => {
					transaction.executeSql(sqlStatement, values, (transaction, result) => {
						if (result != null && result.rows != null) {
							for (var i = 0; i < result.rows.length; i++) {
								var row = result.rows.item(i);
								list.push(this.fromApi(row));
							}
							resolve(list);
						}
					}, (transaction, error) => {
						var e = new GenericError();
						e.setAndLogMessage("Error: " + error.message);
						reject(e);
					});
				}, (transaction, error) => {
					var e = new GenericError();
					e.setAndLogMessage("Error: " + error.message);
					reject(e);
				});
			}
		})
	}

	_createConditionStatement(columns, operators) {
		var columnStatement = "";
		for (let i = 0; i < columns.length; i++) {

			let operator = "=";
			if (operators != null && operators[i] != null) {
				operator = operators[i];
			}
			columnStatement += columns[i] + operator + "? ";

			if (i !== columns.length - 1) {
				columnStatement += "AND ";
			}
		}
		return columnStatement;
	}

	search = (table, column, values) => {
		return new Promise((resolve, reject) => {
			var db = openDatabase(DatabaseInfo.dbName, DatabaseInfo.version, DatabaseInfo.name, DatabaseInfo.size);
			var searchedList = [];
			if (!db) {
				var e = new GenericError();
				e.setAndLogMessage("Database hasn't been created!");
				reject(e);
			} else {
				db.transaction((transaction) => {
					var statement = "SELECT * FROM stations WHERE sound LIKE '" + values[0] + "%' UNION ALL SELECT * FROM stations WHERE sound LIKE '% %" + values[0] + "%' LIMIT 20";
					transaction.executeSql(statement, [], (transaction, result) => {
						if (result != null && result.rows != null) {
							for (var i = 0; i < result.rows.length; i++) {
								var row = result.rows.item(i);
								searchedList.push(this.fromApi(row));
							}
							resolve(searchedList);
						}
					}, (transaction, error) => {
						var e = new GenericError();
						e.setAndLogMessage("SQL query Error: " + error.message);
						reject(e);
					});
				}, (transaction, error) => {
					var e = new GenericError();
					e.setAndLogMessage("Error: " + error.message);
					reject(e);
				});
			}
		})
	}

	update = (table, statement, values) => {
		return new Promise((resolve, reject) => {
			var db = openDatabase(DatabaseInfo.dbName, DatabaseInfo.version, DatabaseInfo.name, DatabaseInfo.size);
			db.transaction((transaction) => {
				transaction.executeSql(statement, values, (transaction, result) => { }, (transaction, error) => {
					var e = new GenericError();
					e.setAndLogMessage("Update table Error: " + error.message);
					reject(e);
				});
			})
		})
	};

	checkTableRowsCount(table) {
		return new Promise((resolve, reject) => {
			var db = openDatabase(DatabaseInfo.dbName, DatabaseInfo.version, DatabaseInfo.name, DatabaseInfo.size);
			db.transaction(function (transaction) {
				transaction.executeSql("SELECT COUNT(*) AS totalCount FROM " + table + ";", [], function (transaction, result) {
					if (result != null && result.rows != null) {
						resolve(result.rows.item(0).totalCount);
					}
				}, (transaction, error) => { resolve(null); });
			}, (transaction, error) => { resolve(null); });
		})
	}

	// dropTable(table) {
	// 	return new Promise((resolve, reject) => {
	// 		var db = openDatabase(DatabaseInfo.dbName, DatabaseInfo.version, DatabaseInfo.name, DatabaseInfo.size);
	// 		if (!db) {
	// 			console.log("Database hasn't been created!");
	// 		} else {
	// 			db.transaction(function (transaction) {
	// 				transaction.executeSql("DROP TABLE IF EXISTS " + table + ";", [], function (transaction, result) {
	// 					resolve();				
	// 				}, (transaction, error) => {
	// 					var e = new GenericError();
	// 					e.setAndLogMessage("Drop table Error: " + error.message);
	// 					reject(e);
	// 				});
	// 			}, (transaction, error) => {
	// 				var e = new GenericError();
	// 				e.setAndLogMessage("Error: " + transaction.message);
	// 				reject(e);
	// 			});
	// 		}
	// 	})
	// }

	query(statement, callback) {
		var rows = [];
		var db = openDatabase(DatabaseInfo.dbName, DatabaseInfo.version, DatabaseInfo.name, DatabaseInfo.size);
		db.transaction(function (transaction) {
			transaction.executeSql(statement, [], function (transaction, result) {
				if (result != null && result.rows != null) {
					for (var i = 0; i < result.rows.length; i++) {
						var row = result.rows.item(i);
						rows.push(row);
					}
					callback(rows);
				}
			}, (transaction, error) => {
				var e = new GenericError();
				e.setAndLogMessage("SQL query Error: " + error.message);
				callback(null, e);
			});
		}, (transaction, error) => {
			var e = new GenericError();
			e.setAndLogMessage("Error: " + transaction.message);
			callback(null, e);
		});
	};
}

export default WebSQL;